import logo from "../../assets/logo/iec_logo.png";

const Maintenance = () => {
	const now = new Date();

	const currentYear = now.getUTCFullYear();

	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-navbar-bg">
			{/* Header */}
			<header className="flex w-full items-center px-8 pt-4">
				<div className="container flex items-center justify-between">
					{/* <Link
            to="/"
            className="text-xl font-bold text-blue-600 flex items-center p-2"
          >
            <img src={logo} alt="Logo" />
          </Link> */}
					<img src={logo} alt="Logo" />
				</div>
			</header>

			{/* Main Content */}
			<main className="flex w-full flex-1 items-center justify-center p-8">
				<section>
					<div className="mx-auto max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
						<div className="mx-auto max-w-screen-sm text-center">
							<h1 className="mb-4 animate-spin font-extrabold text-7xl text-button-bg tracking-tight lg:text-9xl">
								⚙️
							</h1>

							<p className="mb-4 font-bold text-3xl text-white tracking-tight md:text-4xl">
								We'll be back soon.
							</p>
							<p className="mb-4 font-light text-gray-400 text-xl">
								{/* Our application is currently under maintenance. We're working
                hard to bring it back online within the next hour. */}
								Our application is currently under maintenance. Thank you for your patience.
								{/* Our application is currently under maintenance as part of the scheduled work on Tuesday, October 7th, from 3:00 PM to 8:00 PM (UTC). Thank you for your patience. */}
							</p>
							{/* <a
                href="/"
                className="inline-flex text-white bg-button-bg hover:bg-button-hover focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center focus:ring-primary-900 my-4"
              >
                Back to Homepage
              </a> */}
						</div>
					</div>
				</section>
			</main>

			{/* Footer */}
			<footer className="flex w-full items-center justify-between px-8 pb-4">
				<div className="container mx-auto flex items-center justify-between">
					<p className="font-bold font-sans text-lg text-white leading-7">
						&copy; {currentYear} IEC TELECOM.
						<span className="font-normal leading-9"> All rights reserved.</span>
					</p>
				</div>
			</footer>
		</div>
	);
};

export default Maintenance;
